import { assert as e, eulerAnglesFromQuaternion as t, quaternionFromEulerAngles as n, stringify as r } from "@magnopus-opensource/magnopus-web-common";
import { AvatarPlayMode as i, AvatarState as a, LocomotionModel as o } from "@magnopus-opensource/connected-spaces-platform-web-api";
//#region src/lib/services/olympus/olympus-game-api.ts
var s = (s) => {
	let { spaces: c, spaceEntities: l, internalEvents: u, chat: d } = s, f;
	return {
		startSession: (t, n, i, a) => {
			console.log(`Start Session Multiplayer:${n.metadata.multiplayerVersion}, ${JSON.stringify(i, r)}`), f = t, e(n);
			let o = n.metadata?.site ?? "Empty", s = [];
			return s.push(f.loadScene(o, { clippingPlanes: n.metadata.renderingHints.commonRenderingHints.clippingPlanes })), l && s.push(c.enter({
				id: n.id,
				asGuest: a,
				needUpdate: !0
			})), d && d.connect(), {
				initialValues: i,
				loading: s
			};
		},
		startOfflinePreviewSession: (t, n, r, i) => {
			f = t, e(n);
			let a = n.metadata?.site ?? "Empty";
			return { loading: [f.loadScene(a, { clippingPlanes: n.metadata.renderingHints.commonRenderingHints.clippingPlanes }), c.enter({
				id: n.id,
				offlineSpaceData: r,
				assetManager: i
			})] };
		},
		spawnPreviewCamera: (r) => {
			e(f);
			let i = r ?? f.getStartLocation();
			if (i) {
				let e = t(i.rotation);
				e[0] = 0, e[2] = 0, i.rotation = n(e);
			}
			f.addPreviewCamera(i);
		},
		spawnPlayer: async (r, s) => {
			if (e(f), s) {
				let e = t(s.rotation);
				e[0] = 0, e[2] = 0, s.rotation = n(e);
			}
			let c = f.addLocalPlayer(s, r.avatar.avatarId), d = await l.createPlayer(r.displayName, {
				type: "Avatar",
				userId: r.userId,
				state: a.Idle,
				agoraUserId: r.agoraUserId.toString(),
				avatarPlayMode: r.avatarPlayMode,
				locomotionModel: r.avatarPlayMode === (i.Creator || i.AR) ? o.FreeCamera : o.Grounded,
				handRotation: [
					0,
					0,
					0,
					1
				],
				headRotation: [
					0,
					0,
					0,
					1
				],
				isHandIKEnabled: !1,
				targetHandIKTargetLocation: [
					0,
					0,
					0
				],
				torsoTwistAlpha: 0,
				walkRunBlendPercentage: 0,
				movementDirection: [
					0,
					0,
					0
				],
				isVisible: r.isAvatarVisible,
				isARVisible: r.isAvatarARVisible,
				isVirtualVisible: r.isAvatarVisible,
				avatarId: r.avatarId,
				avatarUrl: r.avatarUrl
			}, f.getStartLocation());
			await c, u.fire("v2-player-created", {
				playerEntity: d,
				isLocal: !0
			}), l.listenNetworkEvent("emote", (e) => {
				u.fire("emote-event-received", { args: e });
			});
		},
		endSession: async (e) => {
			if (l?.stopListenNetworkEvent("emote"), d.disconnect(), f) try {
				f.destroy(), f = void 0;
			} catch (e) {
				console.warn("error destroying renderer", e);
			}
			return await c.exit(e), !0;
		}
	};
};
//#endregion
export { s as createOlympusGameApi };
